export const GET_WORKS_UNIT='GET_WORKS_UNIT'
export const GET_JOB_TITLE='GET_JOB_TITLE'
export const SET_RESPONDEN_INFO='SET_RESPONDEN_INFO'
export const SET_TAB='SET_TAB'
export const RESET_RESPONDEN='RESET_RESPONDEN'
export const GET_RESPONDENT_COLUMN='GET_RESPONDENT_COLUMN'